import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { OrderView } from '../../../../orders/order';
import { ordersService } from '../../../../orders/ordersService';
import { appConfig } from '@ami/react/core';
import { Modal } from '@ami/react/core';
import OrderShipmentComponent from './OrderShipmentComponent';
import ConfirmCompletionDateModalComponent from './ConfirmCompletionDateModalComponent';
import MarkShippedModalComponent from './MarkShippedModalComponent';
import { formatDateLongMonth } from '@ami/react/core';
import { ProductConfiguration } from '../../../../products/productConfiguration';
import { isAmiUserAuthorizedToManageOrderShipping } from '../../../../authorization/amiPermissions';

const UnshipConfirmationModal = ({
  show,
  shipment,
  onShowUpdated,
  onConfirm,
  submitting,
}) => (
  <Modal
    title="Unship shipment"
    show={show}
    onShowUpdated={onShowUpdated}
    okTitle="Save"
    cancelTitle="Cancel"
    onOk={onConfirm}
    showCancel={true}
    submitting={submitting}
    closeOnOk={false}
  >
    <p>
      Are you sure you want to unship this shipment (
      {shipment && (
        <strong>{formatDateLongMonth(shipment.shipmentDate)}</strong>
      )}
      )?
    </p>
  </Modal>
);

export default class OrderShipmentsContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shipmentToConfirm: null,
      shipmentToMarkShipped: null,
      shipmentToUnship: null,
      changingShipmentStatus: false,
    };

    this.confirmShipment = this.confirmShipment.bind(this);
    this.markShipped = this.markShipped.bind(this);
    this.unshipShipment = this.unshipShipment.bind(this);
  }

  static propTypes = {
    order: PropTypes.instanceOf(OrderView).isRequired,
    onShipmentsUpdated: PropTypes.func.isRequired,
    productConfiguration: PropTypes.instanceOf(ProductConfiguration).isRequired,
  };

  confirmShipment(sendNotification) {
    this.setState({ changingShipmentStatus: true });
    ordersService
      .confirmShipment(this.props.order.id, this.state.shipmentToConfirm.id, {
        sendNotification,
      })
      .then(() => {
        this.setState({
          shipmentToConfirm: null,
          changingShipmentStatus: false,
        });
        this.props.onShipmentsUpdated();
      })
      .catch(() => {
        this.setState({ changingShipmentStatus: false });
      });
  }

  markShipped(
    freightCarrierId,
    trackingNumber,
    shippedDate,
    notificationSchedule
  ) {
    this.setState({ changingShipmentStatus: true });
    ordersService
      .markShipped(this.props.order.id, this.state.shipmentToMarkShipped.id, {
        freightCarrierId,
        trackingNumber,
        shippedDate,
        notificationSchedule,
      })
      .then(() => {
        this.setState({
          shipmentToMarkShipped: null,
          changingShipmentStatus: false,
        });
        this.props.onShipmentsUpdated();
      })
      .catch(() => {
        this.setState({ changingShipmentStatus: false });
      });
  }

  unshipShipment() {
    this.setState({ changingShipmentStatus: true });
    ordersService
      .unshipShipment(this.props.order.id, this.state.shipmentToUnship.id)
      .then(() => {
        this.setState({
          shipmentToUnship: null,
          changingShipmentStatus: false,
        });
        this.props.onShipmentsUpdated();
      })
      .catch(() => {
        this.setState({ changingShipmentStatus: false });
      });
  }

  render() {
    const canConfirmOrMarkShipped =
      appConfig.isManagementApp &&
      this.props.order.status !== 'Cancelled' &&
      isAmiUserAuthorizedToManageOrderShipping();
    return (
      <Fragment>
        <div className="order-shipments">
          {this.props.order.shipments.map((shipment, i) => (
            <OrderShipmentComponent
              key={i}
              shipment={shipment}
              order={this.props.order}
              canChangeStatus={canConfirmOrMarkShipped}
              onConfirmDateButtonClicked={() =>
                this.setState({ shipmentToConfirm: shipment })
              }
              onMarkShippedButtonClicked={() =>
                this.setState({ shipmentToMarkShipped: shipment })
              }
              onUnshipButtonClicked={() =>
                this.setState({ shipmentToUnship: shipment })
              }
              productConfiguration={this.props.productConfiguration}
              loadOrder={this.props.onShipmentsUpdated}
            />
          ))}
          {this.props.order.shipments.length === 0 && (
            <div className="row">
              <div className="col text-center">This order has no shipments</div>
            </div>
          )}
        </div>
        {canConfirmOrMarkShipped && (
          <React.Fragment>
            {this.state.shipmentToConfirm && (
              <ConfirmCompletionDateModalComponent
                show={this.state.shipmentToConfirm !== null}
                shipment={this.state.shipmentToConfirm}
                onShowUpdated={(show) => {
                  if (!show) this.setState({ shipmentToConfirm: null });
                }}
                onConfirmCompletionDate={this.confirmShipment}
                submitting={this.state.changingShipmentStatus}
              />
            )}
            <MarkShippedModalComponent
              show={this.state.shipmentToMarkShipped !== null}
              onShowUpdated={(show) => {
                if (!show) this.setState({ shipmentToMarkShipped: null });
              }}
              onMarkShipped={this.markShipped}
              submitting={this.state.changingShipmentStatus}
            />
            <UnshipConfirmationModal
              show={this.state.shipmentToUnship !== null}
              shipment={this.state.shipmentToUnship}
              onShowUpdated={(show) => {
                if (!show) this.setState({ shipmentToUnship: null });
              }}
              onConfirm={this.unshipShipment}
              submitting={this.state.changingShipmentStatus}
            />
          </React.Fragment>
        )}
      </Fragment>
    );
  }
}
